export const SAVED_QUERY_MARKET_OPTIONS = [
  "ATS",
  "O/U",
  "ML Bet",
  "Dog",
  "PO",
];

/**
 * Internal UI value for “no market” (stored as null in the API).
 * Do not use "" — MUI Select treats empty string poorly and can snap to the first real option (ATS).
 */
export const UNDEFINED_MARKET_SENTINEL = "__undefined__";

/** Saved-queries page filter `<select>` (same sentinel). */
export const UNDEFINED_MARKET_FILTER_VALUE = UNDEFINED_MARKET_SENTINEL;

/** MUI `Select` / `MenuItem` value for unset market. */
export const UNDEFINED_MARKET_SELECT_VALUE = UNDEFINED_MARKET_SENTINEL;

export const UNDEFINED_MARKET_LABEL = "Undefined";

export function isSavedQueryMarketValue(v) {
  return SAVED_QUERY_MARKET_OPTIONS.includes(v);
}

/** Maps DB/API value to Select `value` (valid code or sentinel for undefined). */
export function savedQueryMarketToSelectValue(v) {
  if (v == null || v === "") {
    return UNDEFINED_MARKET_SELECT_VALUE;
  }
  return isSavedQueryMarketValue(v) ? v : UNDEFINED_MARKET_SELECT_VALUE;
}

/** Payload for create/update: null when unset or invalid (e.g. legacy rows). */
export function selectValueToSavedQueryMarketPayload(v) {
  if (
    v == null ||
    v === "" ||
    v === UNDEFINED_MARKET_SELECT_VALUE
  ) {
    return null;
  }
  return isSavedQueryMarketValue(v) ? v : null;
}
